<template>
  <div :class="ns.b()">
    <Vue3Marquee
      :vertical="props.vertical"
      :direction="direction"
      :duration="duration"
      :delay="delay"
      :loop="loop"
      :pause-on-hover="pauseOnHover"
      :clone="clone"
      :animate-on-overflow-only="animateOnOverflowOnly"
      :gradient="gradient"
      :gradient-color="gradientColor"
      :gradient-width="gradientWidth"
      :gradient-length="gradientLength"
      :pause-on-click="pauseOnClick"
      :pause="pause"
      :style="{ height: vertical === true ? `${height}px` : '' }"
    >
      <slot />
    </Vue3Marquee>
  </div>
</template>

<script setup lang="ts">
import { Vue3Marquee } from 'vue3-marquee'
import { useNamespace } from '@lit-element/hooks'
import { marqueeProps } from './marquee'

defineOptions({
  name: 'LtMarquee',
})
const ns = useNamespace('marquee')
const props = defineProps(marqueeProps)
</script>

<style></style>
